import React, {memo, useContext, useMemo} from 'react';

import {NumberInput} from 'src/components/input';
import {MAX_NUMBER_VALUE} from 'src/constants';

import {Integer} from '@pb/kit-component-formatters';
import {LocaleContext} from '@pb/kit-context-locale';

import {LicenseLimitItemLabel} from './license-limit-item-label';

import type {OnChangeLimits} from '../typedef';
import type {DictionaryItem} from 'src/openapi/admin/models/DictionaryItem';


type Props = {
    limitId: string,
    limitDictionary: DictionaryItem,
    onChangeLimit: OnChangeLimits,
    onClearCustomLimit: (code: string) => void,

    defaultValue: number,
    customValue: number,
    readonly?: boolean,
};

export const LicenseLimitItem = memo((props: Props) => {
    const {
        limitId,
        limitDictionary,
        onChangeLimit,
        onClearCustomLimit,

        defaultValue,
        customValue,

        readonly,
    } = props;

    const {locale} = useContext(LocaleContext);

    const value = useMemo(() => {
        if (customValue !== undefined) {
            if (customValue === MAX_NUMBER_VALUE) {
                return undefined;
            } else {
                return customValue;
            }
        }
    }, [customValue]);

    const displayedValue = useMemo(() => {
        return customValue === MAX_NUMBER_VALUE ? 'Unlimited' : Integer.format(customValue, locale);
    }, [customValue, locale]);

    return (
        <NumberInput
            id={`limit-${limitId}`}
            labelId={`limit-${limitId}-label`}
            value={value}
            onBlur={newValue => onChangeLimit(limitDictionary.code, newValue)}
            displayedValue={displayedValue}
            label={(
                <LicenseLimitItemLabel
                    limitId={limitId}
                    limitDictionary={limitDictionary}
                    onClearCustomLimit={onClearCustomLimit}
                    defaultValue={defaultValue}
                    customValue={customValue}
                />
            )}
            readOnly={readonly}
            maxValue={99999999}
        />
    );
});
